import React, {useCallback, useState} from "react";
import {Button, Drawer, IconButton} from "@material-ui/core";
import {DrawerContent} from "../Desktop/WindowPaneComponents/DrawerContent";
import {FindEntityInScope, loadScope} from "../../../state/slices/entityScope";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {fillEntityLevel} from "../../../state/slices/CoreEntity";
import useCurrentUser from "../../../hooks/useCurrentUser";
import {useTheme} from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import AddBoxIcon from "@material-ui/icons/AddBox";
import { useFlags } from "launchdarkly-react-client-sdk";

// (ノಠ益ಠ)ノ彡┻━┻
export const AddEntityIcon = (props) => {
    const [drawerState, setDrawerState] = useState({
        open: false,
        contentType: "",
        anchor: "right",
    });
    const theme = useTheme();

    const { valetArea } = useFlags();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const dispatch = useDispatch();
    const user = useCurrentUser();
    const entityScopeList = useSelector((state) => state.entityScope.available, shallowEqual);
    const entity = useSelector((state) => state.orgTree.entities[props.entityId], shallowEqual);
    const contextId = useSelector((state) => state.coreEntities.ContextID, shallowEqual);
    const contextName = useSelector((state) => {
        const contextId = state.coreEntities.ContextID
        return state.coreEntities.entities[contextId]?.name
    }, shallowEqual);
    const facilityGroupID = useSelector(
        (state) => state.entityScope?.facilityGroupId
    );

    const loadEntity = useCallback(
        async (eid, fgid) => {
            if (fgid) {
                await dispatch(fillEntityLevel({entityID: fgid, userID: user.UserID, currentContextID: eid, isAdminPass: true}))
            } else {
                await dispatch(fillEntityLevel({entityID: eid, userID: user.UserID, currentContextID: eid, isAdminPass: true}))
            }
        },
        [dispatch, user]
    );

    const handleAddEntity = async () => {
        closeDrawer();
        await loadEntity(props.entityId, facilityGroupID);

        if (FindEntityInScope(entityScopeList, entity.entityID)) {
            await dispatch(loadScope({ contextEntity: { id: contextId, name: contextName }, valetAreaFlag: valetArea }));
            // Any code here will wait until the API call completes
        }
    };

    const closeDrawer = () => {
        setDrawerState({
            open: false,
            contentType: "",
            anchor: drawerState.anchor,
        });
    };

    const selectionCallback = (typeName) => {
        setDrawerState({
            open: true,
            contentType: "add-" + typeName.toLowerCase(),
            anchor: "right",
        });
    };
    const handleDeleteEntity = () => {
        closeDrawer();
    };

    return (
        <>
            {isMobile ?
                <IconButton
                    onClick={() =>
                        setDrawerState({
                            contentType: "child-selector",
                            anchor: "bottom",
                            open: true
                        })
                    }
                    color="action"
                    aria-label="add entity"
                    component="div"
                >
                    <AddBoxIcon fontSize={"inherit"}/>
                </IconButton> :
                <Button
                    onClick={() =>
                        setDrawerState({
                            contentType: "child-selector",
                            anchor: "right",
                            open: true
                        })
                    }
                    variant="outlined"
                    size="small"
                    color="primary"
                    data-name={entity?.name}
                >
                    Add Entity
                </Button>

            }

            <Drawer
                style={{minWidth: 400}}
                anchor={drawerState.anchor}
                open={drawerState.open}
                onClose={closeDrawer}
            >
                <div
                    style={{padding: 20}}
                    className={`type_${drawerState.contentType}`}
                >
                    <DrawerContent
                        contentType={drawerState.contentType}
                        entityId={props.entityId}
                        selectionCallback={selectionCallback}
                        handleAddEntity={handleAddEntity}
                        handleDeleteEntity={handleDeleteEntity}
                        closeDrawer={() => {
                            setDrawerState({
                                open: false,
                                contentType: "",
                                anchor: drawerState.anchor,
                            });
                        }}
                    />
                </div>
            </Drawer>
        </>
    )
};